import { Seo } from '@frontend/shared/web';

import { GlobalFilters } from '../../components/filters/GlobalFilters';
import { Header } from '../../components/layout/Header';
import { PerformanceExports } from '../../components/performance/PerformanceExports';

/**
 * Écran « Export » — réservé à la permission `extranet-exports`
 * (cf. `RequirePermission`).
 *
 * Il ne porte plus que les exports : les indicateurs et les graphes qui
 * vivaient ici sont sur le tableau de bord depuis le 11 septembre 2026, où ils
 * ne faisaient que doublon.
 */
export const ExportsRoute = () => (
  <>
    <Seo title="Export — Portail extranet" />
    <Header title="Export" subtitle="Extractions CSV sur la période et le périmètre sélectionnés" />

    <div className="flex-1 overflow-y-auto">
      <div className="px-8 py-6 flex flex-col gap-5">
        <GlobalFilters permission="extranet-exports" />
        <PerformanceExports />
      </div>
    </div>
  </>
);
